/**
 * LoveLab wishlist — guest: localStorage; logged-in: Shopify customer metafield.
 */
(function () {
  var GUEST_KEY = 'lovelab-wishlist';
  var MAX_ITEMS = 50;
  var persistTimer = null;
  var mergeDone = false;

  function account() {
    return window.LLWishlistAccount || { loggedIn: false, customerId: null, items: [] };
  }

  function accountKey() {
    var id = account().customerId;
    return id ? GUEST_KEY + '-c-' + id : GUEST_KEY;
  }

  function storageKey() {
    return account().loggedIn && account().customerId ? accountKey() : GUEST_KEY;
  }

  function readKey(key) {
    try {
      var raw = localStorage.getItem(key);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (i) { return i && i.id; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeKey(key, items) {
    localStorage.setItem(key, JSON.stringify(items));
  }

  function normalizeItem(item) {
    if (!item || item.id == null) return null;
    return {
      id: String(item.id),
      title: item.title || '',
      price: item.price || '',
      image: item.image || '',
      url: item.url || '',
      handle: item.handle || '',
    };
  }

  function mergeLists() {
    var seen = {};
    var out = [];
    for (var a = 0; a < arguments.length; a++) {
      var list = arguments[a] || [];
      for (var i = 0; i < list.length; i++) {
        var item = normalizeItem(list[i]);
        if (!item || seen[item.id]) continue;
        seen[item.id] = true;
        out.push(item);
        if (out.length >= MAX_ITEMS) return out;
      }
    }
    return out;
  }

  function shopifyFeatures() {
    try {
      var el = document.getElementById('shopify-features');
      if (el && el.textContent) return JSON.parse(el.textContent);
    } catch (e) {}
    return {};
  }

  function persistAccountWishlist(items) {
    if (!account().loggedIn || !account().customerId) return Promise.resolve(false);

    var value = JSON.stringify(items.map(normalizeItem).filter(Boolean));
    var customerGid = 'gid://shopify/Customer/' + account().customerId;
    var metafields = [
      {
        namespace: 'custom',
        key: 'wishlist',
        type: 'json',
        value: value,
        ownerId: customerGid,
      },
    ];
    var mutation =
      'mutation metafieldsSet($metafields: [MetafieldsSetInput!]!) { metafieldsSet(metafields: $metafields) { userErrors { field message } } }';
    var payload = JSON.stringify({ query: mutation, variables: { metafields: metafields } });
    var features = shopifyFeatures();
    var token = features.accessToken || '';
    var shopId = features.shopId || '';

    function ok(res) {
      return res && res.ok ? res.json() : Promise.resolve(null);
    }

    function succeeded(json) {
      if (!json || json.errors) return false;
      var errors =
        (json.data && json.data.metafieldsSet && json.data.metafieldsSet.userErrors) || [];
      return errors.length === 0 && json.data && json.data.metafieldsSet;
    }

    var tries = [];

    if (shopId) {
      tries.push(
        fetch('https://shopify.com/' + shopId + '/account/customer/api/2025-01/graphql', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query:
              'mutation metafieldsSet($metafields: [MetafieldsSetInput!]!) { metafieldsSet(metafields: $metafields) { userErrors { message } } }',
            variables: {
              metafields: [
                { namespace: 'custom', key: 'wishlist', type: 'json', value: value },
              ],
            },
          }),
        }).then(ok)
      );
    }

    if (token) {
      tries.push(
        fetch('/api/2025-01/graphql.json', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
          },
          body: payload,
        }).then(ok)
      );
    }

    if (!tries.length) return Promise.resolve(false);

    return Promise.all(tries.map(function (p) { return p.catch(function () { return null; }); }))
      .then(function (results) {
        return results.some(succeeded);
      })
      .catch(function () {
        return false;
      });
  }

  function schedulePersist(items) {
    if (!account().loggedIn) return;
    clearTimeout(persistTimer);
    persistTimer = setTimeout(function () {
      persistAccountWishlist(items);
    }, 350);
  }

  function hydrateFromAccount() {
    if (mergeDone || !account().loggedIn) return;
    mergeDone = true;
    var guest = readKey(GUEST_KEY);
    var cache = readKey(accountKey());
    var meta = Array.isArray(account().items) ? account().items : [];
    var merged = mergeLists(cache, meta, guest);
    writeKey(accountKey(), merged);
    if (guest.length) writeKey(GUEST_KEY, []);
    if (JSON.stringify(merged) !== JSON.stringify(meta)) {
      schedulePersist(merged);
    }
  }

  window.getWishlist = function () {
    return readKey(storageKey());
  };

  window.saveWishlist = function (items) {
    try {
      var list = mergeLists(items || []);
      writeKey(storageKey(), list);
      if (typeof updateWishlistUI === 'function') updateWishlistUI();
      schedulePersist(list);
    } catch (e) {
      console.error('Error saving wishlist:', e);
    }
  };

  window.isItemInWishlist = function (id) {
    return window.getWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  };

  window.toggleWishlistItem = function (productData) {
    var list = window.getWishlist();
    var index = list.findIndex(function (item) {
      return String(item.id) === String(productData.id);
    });
    var added = index === -1;
    if (index > -1) list.splice(index, 1);
    else list.push(normalizeItem(productData));
    window.saveWishlist(list);

    // React Sonner parity: title-only success toast
    if (window.llAddedToBagToast && typeof window.llAddedToBagToast.show === 'function') {
      var dict = window.llI18n || {};
      window.llAddedToBagToast.show({
        title: added
          ? dict.addedToWishlist || 'Added to wishlist!'
          : dict.removedFromWishlist || 'Removed from wishlist',
        description: '',
      });
    }
  };

  window.removeWishlistItem = function (id) {
    window.saveWishlist(
      window.getWishlist().filter(function (item) {
        return String(item.id) !== String(id);
      })
    );
  };

  window.LLWishlist = {
    hydrate: hydrateFromAccount,
    persist: persistAccountWishlist,
  };

  hydrateFromAccount();
})();
